import React from "react";
import { ArrowRightIcon } from "../../../shared/components/icons";

/**
 * Single lobby section header, sized to match SocialProofSection's "Recent
 * Activity" heading. Optional `kicker` renders a small uppercase label above the
 * title for sections that warrant a tier marker (slots / live / providers).
 *
 * Module-scope (was defined inside GameLobby's render body) so it is a stable
 * component type across renders.
 */
const SectionHeader = ({ title, kicker, onViewAll }) => (
  <div className="mb-6 flex items-end justify-between gap-4">
    <div>
      {kicker && (
        <p className="text-[11px] md:text-xs uppercase tracking-[0.22em] text-primary font-semibold mb-2 tabular-nums">
          {kicker}
        </p>
      )}
      <h2 className="text-2xl md:text-[1.75rem] font-semibold text-white leading-tight tracking-[-0.01em]">
        {title}
      </h2>
    </div>
    {onViewAll && (
      <button
        onClick={onViewAll}
        className="group inline-flex items-center gap-1.5 flex-shrink-0 whitespace-nowrap text-muted-foreground hover:text-primary font-medium text-sm transition-colors duration-150 cursor-pointer active:scale-[0.97]"
      >
        <span>View all</span>
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary/10 text-primary transition-[transform,background-color] duration-150 ease-out group-hover:bg-primary/20 group-hover:translate-x-0.5">
          <ArrowRightIcon className="w-3 h-3" />
        </span>
      </button>
    )}
  </div>
);

export default SectionHeader;
